// Ensure touches occur rapidly
var delay = 500;
// Sequential touches must be in close vicinity
var minZoomTouchDelta = 10;
// Track state of the last touch
var lastTapAt = 0;
var lastClientX = 0;
var lastClientY = 0;
export default function preventDoubleTapZoom(event) {
    // Exit early if this involves more than one finger (e.g. pinch to zoom)
    if (event.touches.length > 1) {
        return;
    }
    var tapAt = new Date().getTime();
    var timeDiff = tapAt - lastTapAt;
    var _a = event.touches[0], clientX = _a.clientX, clientY = _a.clientY;
    var xDiff = Math.abs(lastClientX - clientX);
    var yDiff = Math.abs(lastClientY - clientY);
    if (xDiff < minZoomTouchDelta &&
        yDiff < minZoomTouchDelta &&
        event.touches.length === 1 &&
        timeDiff < delay) {
        event.preventDefault();
        // Trigger a fake click for the tap we just prevented
        event.target.click();
    }
    lastClientX = clientX;
    lastClientY = clientY;
    lastTapAt = tapAt;
}



// WEBPACK FOOTER //
// ./src/preventDoubleTapping.js